import React from 'react';
import { Button, Loading } from '@brighterion/br-ui';
import { useTranslation } from 'react-i18next';
import styles from './ListEntryTable.css';

type Props = {
    onSubmit: () => void;
    isLoading: boolean;
    isDisabled: boolean;
};

const SearchButton = ({ onSubmit, isLoading, isDisabled }: Props) => {
    const { t } = useTranslation();

    return (
        <Button
            dataTestId='search-button'
            className={styles.searchButton}
            variant='contextual-secondary'
            onClick={() => onSubmit()}
            disabled={isDisabled}
        >
            {isLoading ? (
                <div data-testid='search-loader'>
                    <Loading size='sm' fillName='orange' />
                </div>
            ) : (
                t('Search')
            )}
        </Button>
    );
};

export default React.memo(SearchButton);
